module.exports = __webpack_public_path__ + "img/26-pacifica-nav.ba793046.png";